import requestFormSickLeaveReportsComponent from './requestFormSickLeaveReports.component';

let requestFormSickLeaveReportsModule = angular.module('vacations-absences.requestFormSickLeaveReports', [])

.component('requestFormSickLeaveReports', requestFormSickLeaveReportsComponent)

.name;

export default requestFormSickLeaveReportsModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestFormSickLeaveReports/requestFormSickLeaveReports.js